import { request } from '@/utils/request'
import { cookies } from '@/utils/cookies'
import { reqAddRecord } from '@/api/recordBill'

/* 預約單列表 */
export const reqList = (params) => request.get(`reservation/list`, { params })

/* 單筆預約單的詳細資料 */
export const reqOrderDetail = (id) => request.get(`reservation/info?id=${id}`)

/* 以下和單筆預約單modal相關 */

/* 配對司機列表 */
export const reqDriverList = (params) =>
  request.get(`reservation/driver-received-list`, { params })

/* 點擊傳送訊息給乘客btn觸發 */
export const reqSns = (payload) => request.post(`sns/web`, payload)

/* 點擊司機取消btn觸發 */
export const reqDriverCancel = async (position, payload) => {
  try {
    await reqAddRecord({
      type: '預約單',
      event: '更新司機取消',
      code: cookies.get('GladTeamCode'),
      user_name: cookies.get('GladName'),
      id: payload.reservationId,
      note: payload,
      user_id: '',
    })
    return request.put(`reservation/updateDriver?position=${position}`, payload)
  } catch (e) {
    console.error(e)
  }
}

/* 修改乘客備註 點擊更新btn觸發 */
export const reqUpdatePassengerPosition = async (position, payload) => {
  try {
    await reqAddRecord({
      type: '預約單',
      event: '更新乘客',
      code: cookies.get('GladTeamCode'),
      user_name: cookies.get('GladName'),
      id: payload.reservationId,
      note: payload,
      user_id: '',
    })
    return request.put(
      `reservation/updatePassenger?position=${position}`,
      payload,
    )
  } catch (e) {
    console.error(e)
  }
}

/* 點擊直接完成訂單btn觸發 */
export const reqFinishReservation = async (payload) => {
  try {
    await reqAddRecord({
      type: '預約單',
      event: '更新預約單',
      code: cookies.get('GladTeamCode'),
      user_name: cookies.get('GladName'),
      id: payload.reservationId,
      note: payload,
      user_id: '',
    })
    return request.put(`reservation/finish`, payload)
  } catch (e) {
    console.error(e)
  }
}

/* 未用的api */
export const reqUpdatePassengerInfo = async (payload) => {
  try {
    await reqAddRecord({
      type: '預約單',
      event: '更新乘客',
      code: cookies.get('GladTeamCode'),
      user_name: cookies.get('GladName'),
      id: payload.reservation_id,
      note: payload,
      user_id: '',
    })
    return request.put(`reservation/updatePassengerInfo`, payload)
  } catch (e) {
    console.error(e)
  }
}

/* 配對司機列表配對按鈕 */
export const reqDeal = (payload) =>
  request.put(`reservation/driverdeal`, payload)

/* 配對司機列表取消按鈕 */
export const reqCancel = (payload) =>
  request.put(`reservation/canceldriver`, payload)



// WEBPACK FOOTER //
// ./src/api/reservation/index.js